import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    if (! map.syntax.isAvailable) {
        return null
    }

    const onClick = () => map.commands.checkSyntax()

    return {
        key: 'lint-for-code',
        label: '生成文档规范检测',
        onClick,
    }
}
